import React, { useState, useEffect } from "react";
import { Heart, Clock, Users, MapPin, Star } from "lucide-react";
import { useNavigate } from "react-router-dom";
import axios from "axios";


const TrendingCategories = () => {
  const [favorites, setFavorites] = useState(new Set());
  const [tourData, setTourData] = useState([]);
  const navigate = useNavigate();

  
 

  const toggleFavorite = (id) => {
    setFavorites((prev) => {
      const newFavorites = new Set(prev);
      if (newFavorites.has(id)) {
        newFavorites.delete(id);
      } else {
        newFavorites.add(id);
      }
      return newFavorites;
    });
  };

  const fetchToursData = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/tour-details/get-all`,
      );
      setTourData(response?.data?.tours);
      console.log("tourdata",response.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchToursData();
  }, []);

  const loopedTours = [...tourData, ...tourData];

  

  return (
    <div className="pt-4 md:pt-10 px-4 sm:px-6 lg:px-20 ">
      <div className="w-full mx-auto">
        {/* Header Section */}
        <div className="text-center mb-10 animate-fade-in">
          <div className="text-center">
            <div className="flex items-center justify-center gap-3 mb-4">
              <div className="h-px w-16 bg-gradient-to-r from-transparent to-rose-500/60" />
              <div className="flex items-center gap-1.5">
                <svg
                  className="w-5 h-5 text-rose-400"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <path d="M3 17l4-8 4 4 4-6 4 4" />
                  <path d="M21 7l-4 4" />
                </svg>
                <span className="text-rose-400 text-xs font-semibold uppercase tracking-widest">
                  Popular Now
                </span>
              </div>
              <div className="h-px w-16 bg-gradient-to-l from-transparent to-rose-500/60" />
            </div>
          </div>
          <h1 className="text-2xl md:text-4xl font-bold text-gray-900 mb-2 tracking-tight animate-slide-up">
            Our Odisha Tours
          </h1>
          <p className="text-base md:text-lg max-w-xl mx-auto leading-relaxed mb-10">
            Gaining popularity due to advancements in battery technology and
            growing environmental awareness
          </p>
        </div>

        {/* Cards Grid */}
        <div className="overflow-hidden w-full">
  <div className="flex gap-6 animate-scroll pb-3">
         {loopedTours
  ?.filter((tour) => tour?.tourType?.name === "Odisha")
  ?.map((tour, index) => (
    <div
      key={index}
      className="min-w-[300px] max-w-[300px] flex-shrink-0 group bg-white rounded-2xl overflow-hidden shadow-md hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-2 cursor-pointer"
      onClick={() => navigate(`/tour-details/${tour?._id}`)}
    >
                {/* Image Container */}
                <div className="relative h-64 overflow-hidden">
                  <img
                    src={tour?.images?.[0]}
                    alt={tour?.name}
                    className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                  />
                  {/* Gradient Overlay */}
                  <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>

                  {/* Favorite Button */}
                  <button
                    onClick={() => toggleFavorite(tour._id)}
                    className="absolute top-3 right-3 bg-white rounded-full p-2 shadow-lg hover:scale-110 transition-transform duration-300 z-10"
                    aria-label="Add to favorites"
                  >
                    <Heart
                      className={`w-5 h-5 transition-colors duration-300 ${
                        favorites.has(tour._id)
                          ? "fill-red-500 text-red-500"
                          : "text-gray-600"
                      }`}
                    />
                  </button>

                  {/* Location Badge */}
                  <div className="absolute bottom-3 left-3 bg-white/95 backdrop-blur-sm rounded-full px-3 py-1 flex items-center space-x-1 shadow-lg animate-slide-in-left">
                    <span className="text-lg">{tour.flag}</span>
                    <MapPin className="w-3 h-3 text-orange-500" />
                  </div>
                </div>

                {/* Content */}
                <div className="p-4">
                  {/* Rating & Location */}
                  <div className="flex justify-between gap-5">
                    <span className="text-lg font-bold text-gray-900 line-clamp-1">
                      {tour?.location}
                    </span>
                    <div className="flex flex-row gap-1">
                      <Star className="w-4 h-4 fill-orange-400 text-orange-400 mt-0.5" />
                      <span className="text-sm text-gray-900">
                        ({tour?.review})5
                      </span>
                    </div>
                  </div>

                  {/* Title */}
                  <h3 className="md:text-lg font-semibold text-gray-900 mb-3 line-clamp-2 leading-tight group-hover:text-orange-600 transition-colors duration-300">
                    {tour?.title}
                  </h3>

                  {/* Details */}
                  <div className="flex items-center justify-between text-xs text-gray-600 mb-3">
                    <div className="flex items-center space-x-1">
                      <Clock className="w-3.5 h-3.5 text-orange-500" />
                      <span>{tour?.overview?.duration}</span>
                    </div>
                    <div className="flex items-center space-x-1">
                      <Users className="w-3.5 h-3.5 text-orange-500" />
                      <span>{tour?.overview?.travelers}</span>
                    </div>
                  </div>

                  {/* Price */}
                  <div className="flex items-center justify-between pt-3 border-t border-gray-100">
                    <div className="flex items-baseline space-x-1">
                      <span className="text-xs text-gray-500">from</span>
                      <span className="text-sm line-through text-gray-900">
                        ₹{tour?.basePrice}
                      </span>
                      <span className="text-xl font-bold text-green-700">
                        ₹{tour?.offerPrice}
                      </span>
                      <span className="text-xs text-gray-500">/person</span>
                    </div>
                    <button className="text-orange-500 hover:text-orange-600 transform hover:scale-110 transition-all duration-300">
                      <svg
                        className="w-5 h-5"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M9 5l7 7-7 7"
                        />
                      </svg>
                    </button>
                  </div>
                </div>
                

                {/* Hover Effect Border */}
                {/* <div className="absolute inset-0 border-2 border-transparent group-hover:border-orange-400 rounded-2xl transition-all duration-300 pointer-events-none"></div> */}
              </div>
              
            ))}
        </div>
        </div>

        {/* View All Button */}
        <div
          className="flex justify-center animate-fade-in"
          style={{ animationDelay: "800ms" }}
        >
          <button
            onClick={() => navigate(`/tour`)}
            className="group relative px-8 py-3.5 bg-gray-900 text-white rounded-full font-semibold shadow-lg hover:shadow-2xl transform hover:scale-105 transition-all duration-300 overflow-hidden"
          >
            <span className="relative z-10 flex items-center space-x-2">
              <span>View All</span>
              <svg
                className="w-5 h-5 group-hover:translate-x-1 transition-transform duration-300"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M17 8l4 4m0 0l-4 4m4-4H3"
                />
              </svg>
            </span>
            <div className="absolute inset-0 bg-gradient-to-r from-orange-500 to-pink-500 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
          </button>
        </div>

        {/* Pagination Dots */}
        {/* <div className="flex justify-center items-center space-x-2 mt-8">
          <button className="w-3 h-3 rounded-full bg-orange-400 animate-pulse"></button>
          <button className="w-2 h-2 rounded-full bg-gray-300 hover:bg-gray-400 transition-colors duration-300"></button>
          <button className="w-2 h-2 rounded-full bg-gray-300 hover:bg-gray-400 transition-colors duration-300"></button>
        </div> */}
      </div>

      {/* Custom Styles */}
      <style jsx>{`
      @keyframes scroll {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-50%);
  }
}

.animate-scroll {
  display: flex;
  width: max-content;
  animation: scroll 25s linear infinite;
}
  .animate-scroll:hover {
  animation-play-state: paused;
}
        @keyframes fade-in {
          from {
            opacity: 0;
          }
          to {
            opacity: 1;
          }
        }

        @keyframes fade-in-up {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes slide-up {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes slide-right {
          from {
            opacity: 0;
            transform: translateX(-10px);
          }
          to {
            opacity: 1;
            transform: translateX(0);
          }
        }

        @keyframes slide-left {
          from {
            opacity: 0;
            transform: translateX(10px);
          }
          to {
            opacity: 1;
            transform: translateX(0);
          }
        }

        @keyframes slide-in-left {
          from {
            opacity: 0;
            transform: translateX(-20px);
          }
          to {
            opacity: 1;
            transform: translateX(0);
          }
        }

        @keyframes bounce-slow {
          0%,
          100% {
            transform: translateY(0);
          }
          50% {
            transform: translateY(-5px);
          }
        }

        .animate-fade-in {
          animation: fade-in 0.8s ease-out;
        }

        .animate-fade-in-up {
          animation: fade-in-up 0.6s ease-out forwards;
          opacity: 0;
        }

        .animate-slide-up {
          animation: slide-up 0.8s ease-out;
        }

        .animate-slide-right {
          animation: slide-right 0.6s ease-out;
        }

        .animate-slide-left {
          animation: slide-left 0.6s ease-out;
        }

        .animate-slide-in-left {
          animation: slide-in-left 0.4s ease-out;
        }

        .animate-bounce-slow {
          animation: bounce-slow 2s ease-in-out infinite;
        }

        .line-clamp-2 {
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
        }
      `}</style>
    </div>
  );
};

export default TrendingCategories;
